export default __webpack_public_path__ + "static/media/training-illustration21.104862f3.png";